import { useAppState } from "../context/store";

const useLoggedIn = () => {
  const { user } = useAppState();

  return Boolean(user);
};

export default useLoggedIn;
